export const getPaginatePaymentLinkMock = {
  forms: [
    {
      id: 'b3d64876-e86c-4820-babc-b85c5c8335c8',
      data: {
        title: 'тест 15',
        coin_id: 'eth',
        network_id: 'eth',
        amount: '0.00039196933231943937',
      },
      checkout_url: '',
      expiration: {
        deadline: '2025-05-16T08:43:43.511Z',
        ui_type: 'one_day',
      },
      one_time: {
        is_one_time: false,
      },
      status: 'expired',
      created_at: '2025-05-15T08:43:42.561889Z',
      updated_at: '2025-05-28T08:58:36.168813Z',
      stats: {
        visits: 1,
        successful_invoices: 0,
        total_payment_amount: '0',
      },
      amount_boundaries: {},
    },
    {
      id: 'a397f46d-8acb-4ac7-997a-a5e325d2ef20',
      data: {
        title: ';;;',
        coin_id: 'usdt',
        network_id: 'trc20',
        amount: '1',
      },
      checkout_url: '',
      expiration: {
        deadline: '2025-05-07T11:30:25.359Z',
        ui_type: 'one_day',
      },
      one_time: {
        is_one_time: false,
      },
      status: 'expired',
      created_at: '2025-05-06T11:30:24.844586Z',
      updated_at: '2025-05-08T08:12:42.734096Z',
      stats: {
        visits: 0,
        successful_invoices: 0,
        total_payment_amount: '0',
      },
      amount_boundaries: {},
    },
    {
      id: '802e6bcc-0027-41ad-9db5-45825c7476b9',
      data: {
        title: 'ccылка бтс',
        coin_id: 'btc',
        amount: '1',
      },
      checkout_url: '',
      expiration: {
        deadline: '2025-04-26T09:21:03.498Z',
        ui_type: 'one_day',
      },
      one_time: {
        is_one_time: false,
      },
      status: 'expired',
      created_at: '2025-04-25T09:21:03.805774Z',
      updated_at: '2025-04-28T13:25:13.525542Z',
      stats: {
        visits: 2,
        successful_invoices: 0,
        total_payment_amount: '0',
      },
      amount_boundaries: {},
    },
    {
      id: '439818d5-c96b-41e9-9806-e31ecf411072',
      data: {
        title: 'test231',
        description: 'test231',
        coin_id: 'usdc',
        network_id: 'trc20',
        amount: '100',
      },
      checkout_url: '',
      expiration: {
        deadline: '2025-05-30T12:03:04.603Z',
        ui_type: 'one_day',
      },
      one_time: {
        is_one_time: false,
      },
      status: 'active',
      created_at: '2025-05-29T12:03:04.773732Z',
      updated_at: '2025-05-29T12:03:04.773732Z',
      stats: {
        visits: 0,
        successful_invoices: 0,
        total_payment_amount: '0',
      },
      amount_boundaries: {},
    },
    {
      id: '6ae83902-517e-437c-8837-9d1095a7eed4',
      data: {
        title: 'test1212',
        description: 'test123123',
        coin_id: 'usdt',
        network_id: 'trc20',
      },
      checkout_url: '',
      expiration: {
        deadline: '2025-06-05T11:39:05.751Z',
        ui_type: 'week',
      },
      one_time: {
        is_one_time: false,
      },
      status: 'active',
      created_at: '2025-05-29T11:39:05.902071Z',
      updated_at: '2025-05-29T11:39:05.902071Z',
      stats: {
        visits: 1,
        successful_invoices: 0,
        total_payment_amount: '0',
      },
      amount_boundaries: {
        min_amount: '1',
        max_amount: '1000',
      },
    },
    {
      id: '0107c0f0-4e36-40f1-afca-10eac5194f77',
      data: {
        title: 'test1231',
        description: 'teasaea',
        coin_id: 'usdt',
        network_id: 'trc20',
        amount: '100',
      },
      checkout_url: '',
      expiration: {
        deadline: '2025-05-30T11:37:53.821Z',
        ui_type: 'one_day',
      },
      one_time: {
        is_one_time: false,
      },
      status: 'active',
      created_at: '2025-05-29T11:37:53.973723Z',
      updated_at: '2025-05-29T11:37:53.973723Z',
      stats: {
        visits: 1,
        successful_invoices: 0,
        total_payment_amount: '0',
      },
      amount_boundaries: {},
    },
    {
      id: '13873949-fe07-4f5b-bfe2-b76dd7fd70a0',
      data: {
        title: 'мрмрмрмрмр!',
        description: '',
        coin_id: 'usdt',
        network_id: 'trc20',
        amount: '1',
      },
      checkout_url: '',
      expiration: {
        deadline: '2025-05-30T11:27:46.549Z',
        ui_type: 'one_day',
      },
      one_time: {
        is_one_time: false,
      },
      status: 'active',
      created_at: '2025-05-29T11:27:34.044182Z',
      updated_at: '2025-05-29T11:27:46.823885Z',
      stats: {
        visits: 0,
        successful_invoices: 0,
        total_payment_amount: '0',
      },
      amount_boundaries: {},
    },
    {
      id: '27d1abea-180e-4312-9dee-05ca9260d138',
      data: {
        title: 'мсормоварвоа!',
        description: '',
        coin_id: 'usdt',
        network_id: 'trc20',
        amount: '1',
      },
      checkout_url: '',
      expiration: {
        deadline: '2025-05-30T11:26:42.762Z',
        ui_type: 'one_day',
      },
      one_time: {
        is_one_time: false,
      },
      status: 'active',
      created_at: '2025-05-29T11:26:28.162095Z',
      updated_at: '2025-05-29T11:26:43.058933Z',
      stats: {
        visits: 0,
        successful_invoices: 0,
        total_payment_amount: '0',
      },
      amount_boundaries: {},
    },
    {
      id: '485de343-6222-4941-a8cd-2560b304bc77',
      data: {
        title: 'ts',
        description:
          'huvbuПлатежные ссылки проще всего можно создать через UX, то есть выбрать необходимую сумму. Можно вообще оставить свободную сумму, тогда покупатель будет в платежной форме.  Сколько она действует? Если мы говорим про интеграцию через API, то мы можем ее уменьшать до одного часа. Название здесь обычно идет как название мерчанта. ',
        coin_id: 'usdt',
        network_id: 'trc20',
        amount: '100',
      },
      checkout_url: '',
      expiration: {
        deadline: '2025-05-30T11:22:18.936Z',
        ui_type: 'one_day',
      },
      one_time: {
        is_one_time: false,
      },
      status: 'active',
      created_at: '2025-05-29T11:22:19.104016Z',
      updated_at: '2025-05-29T11:22:19.104016Z',
      stats: {
        visits: 1,
        successful_invoices: 0,
        total_payment_amount: '0',
      },
      amount_boundaries: {},
    },
    {
      id: 'd107b587-449e-4015-bccb-d702e3175b3a',
      data: {
        title: 'grghrhrhetghg',
        description: '',
        coin_id: 'usdt',
        network_id: 'trc20',
        amount: '1',
      },
      checkout_url: '',
      expiration: {
        deadline: '2025-05-29T09:41:19.969Z',
        ui_type: 'one_day',
      },
      one_time: {
        is_one_time: true,
      },
      status: 'active',
      created_at: '2025-05-28T09:41:20.164212Z',
      updated_at: '2025-05-28T09:41:20.164212Z',
      stats: {
        visits: 0,
        successful_invoices: 0,
        total_payment_amount: '0',
      },
      amount_boundaries: {},
    },
  ],
  total: 44,
}

export const getPaginatePaymentLinkHistoryMock = {
  data: {
    invoices: [
      {
        id: '18a03137-5d4e-49d4-b6b0-2f0af03d612b',
        title: 'прорва',
        description: '',
        expires_at: '2025-06-02T13:57:57.754137Z',
        coin_id: 'usdt',
        network_id: 'trc20',
        payment_amount: '10',
        paid_amount: '0',
        buyer_email: 'dfhj@fjd.tu',
        checkout_url: '',
        status: 'EXPIRED',
        deposit_address: 'TSCbCtvKXS34v6pWi3j75u73xBK3utVyor',
        buyer_fee: '0.1',
        required_payment_amount: '10.1',
        transactions: [],
        created_at: '2025-06-02T13:47:57.752656Z',
        finished_at: '2025-06-02T13:58:55.405819Z',
      },
      {
        id: '03702e24-1385-4751-8a57-f967b2df8cb3',
        title: 'test142314',
        description: 'test142314',
        expires_at: '2025-06-02T13:45:56.504613Z',
        coin_id: 'usdt',
        network_id: 'trc20',
        payment_amount: '200',
        paid_amount: '0',
        buyer_email: 'nic.sadfdsa@bhjsd.cds',
        checkout_url: '',
        status: 'EXPIRED',
        deposit_address: 'TSCbCtvKXS34v6pWi3j75u73xBK3utVyor',
        buyer_fee: '2',
        required_payment_amount: '202',
        transactions: [],
        created_at: '2025-06-02T13:35:56.503382Z',
        finished_at: '2025-06-02T13:46:55.401818Z',
      },
      {
        id: '3e2a5e56-fd60-4264-8519-f2c68dd64939',
        title: '300000',
        description: '',
        expires_at: '2025-05-30T10:04:07.812299Z',
        coin_id: 'usdt',
        network_id: 'trc20',
        payment_amount: '1',
        paid_amount: '0',
        buyer_email: 'fd@df.rt',
        checkout_url: '',
        status: 'EXPIRED',
        deposit_address: 'TSCbCtvKXS34v6pWi3j75u73xBK3utVyor',
        buyer_fee: '0.01',
        required_payment_amount: '1.01',
        transactions: [],
        created_at: '2025-05-30T09:54:07.809015Z',
        finished_at: '2025-05-30T10:04:55.714456Z',
      },
      {
        id: '19d5d8aa-504f-4505-a1f1-6caad2bb5989',
        title: 'test1212',
        description: 'test123123',
        expires_at: '2025-05-29T11:49:52.011123Z',
        coin_id: 'usdt',
        network_id: 'trc20',
        payment_amount: '100',
        paid_amount: '0',
        buyer_email: 'nick.gyuntner@yandex.ru',
        checkout_url: '',
        status: 'EXPIRED',
        deposit_address: 'TSCbCtvKXS34v6pWi3j75u73xBK3utVyor',
        buyer_fee: '1',
        required_payment_amount: '101',
        transactions: [],
        created_at: '2025-05-29T11:39:52.010796Z',
        finished_at: '2025-05-29T11:50:01.828987Z',
      },
      {
        id: '2284b526-f7f9-4c1c-b6f8-ee7262e676db',
        title: 'test3',
        description: 'test3',
        expires_at: '2025-05-08T15:47:26.586801Z',
        coin_id: 'usdt',
        network_id: 'trc20',
        payment_amount: '110',
        paid_amount: '0',
        buyer_email: 'nick.guntner@yandex.ru',
        checkout_url: '',
        status: 'EXPIRED',
        deposit_address: 'TSCbCtvKXS34v6pWi3j75u73xBK3utVyor',
        buyer_fee: '1.1',
        required_payment_amount: '111.1',
        transactions: [],
        created_at: '2025-05-08T15:37:26.585656Z',
        finished_at: '2025-05-08T15:48:04.328394Z',
      },
      {
        id: '261aec82-3799-4c47-96b6-558fd3dda91c',
        title: 'test 06',
        description: '',
        expires_at: '2025-05-06T11:19:46.702368Z',
        coin_id: 'usdt',
        network_id: 'trc20',
        payment_amount: '1',
        paid_amount: '0',
        buyer_email: 'yu@hf.tu',
        checkout_url: '',
        status: 'EXPIRED',
        deposit_address: 'TSCbCtvKXS34v6pWi3j75u73xBK3utVyor',
        buyer_fee: '0.01',
        required_payment_amount: '1.01',
        transactions: [],
        created_at: '2025-05-06T11:09:46.798569Z',
        finished_at: '2025-05-06T11:20:04.870239Z',
      },
      {
        id: 'b8433820-dcfd-4326-9e79-ec389f96e92f',
        title: 'New Case',
        description: 'tur',
        expires_at: '2025-04-28T13:36:12.450739Z',
        coin_id: 'usdt',
        network_id: 'trc20',
        payment_amount: '10',
        paid_amount: '0',
        buyer_email: 'tets@gmail.com',
        checkout_url: '',
        status: 'EXPIRED',
        deposit_address: 'TSCbCtvKXS34v6pWi3j75u73xBK3utVyor',
        buyer_fee: '0.1',
        required_payment_amount: '10.1',
        transactions: [],
        created_at: '2025-04-28T13:26:12.454574Z',
        finished_at: '2025-04-28T13:37:04.861005Z',
      },
      {
        id: '58d334d9-baa7-4a3c-97a0-ea71a226f279',
        title: 'Test invoice form',
        description: 'First prod test invoice form',
        expires_at: '2025-04-24T14:04:50.211944Z',
        coin_id: 'usdt',
        network_id: 'trc20',
        payment_amount: '2',
        paid_amount: '2.02',
        buyer_email: 'drugpluto@gmail.com',
        checkout_url: 'https://yandex.ru',
        status: 'FINISHED',
        deposit_address: 'TSW52dZQLs6o7DWBqBTus3bZXAHDTDiYD5',
        buyer_fee: '0.02',
        required_payment_amount: '2.02',
        transactions: [
          {
            hash: 'f9717393094a87cfff7c5dc168b1f0e4256b54a74942f74b738107b42a6e9f4f',
            amount: '2.02',
            address: 'TSW52dZQLs6o7DWBqBTus3bZXAHDTDiYD5',
            status: 'TRANSACTION_STATUS_CONFIRMED',
            created_at: '1970-01-01T00:00:00Z',
          },
        ],
        created_at: '2025-04-24T13:54:50.217571Z',
        finished_at: '2025-04-24T13:58:50.2041Z',
      },
      {
        id: 'cda1b08f-d3a9-43d8-8f30-37fcf522e86d',
        title: 'Test invoice form',
        description: 'First prod test invoice form',
        expires_at: '2025-04-24T10:06:04.496115Z',
        coin_id: 'usdt',
        network_id: 'trc20',
        payment_amount: '2',
        paid_amount: '0',
        buyer_email: '',
        checkout_url: 'https://yandex.ru',
        status: 'EXPIRED',
        deposit_address: 'TSW52dZQLs6o7DWBqBTus3bZXAHDTDiYD5',
        buyer_fee: '0.02',
        required_payment_amount: '2.02',
        transactions: [],
        created_at: '2025-04-24T09:56:04.506902Z',
        finished_at: '2025-04-24T10:06:04.758035Z',
      },
      {
        id: 'fc48c241-d105-452a-a35e-fd19416ca65d',
        title: 'Test invoice form',
        description: 'First prod test invoice form',
        expires_at: '2025-03-24T17:54:11.746662Z',
        coin_id: 'usdt',
        network_id: 'trc20',
        payment_amount: '2',
        paid_amount: '2.02',
        buyer_email: '',
        checkout_url: 'https://yandex.ru',
        status: 'FINISHED',
        deposit_address: 'TQa2sk4Ymo4SKPYXXWrHND333ynMvrfGqn',
        buyer_fee: '0.02',
        required_payment_amount: '2.02',
        transactions: [
          {
            hash: '7ede80ed0accdc0fb6af555cbc82a2df5b0ee168efee105fd3e9db6325eae7a9',
            amount: '2.02',
            address: 'TQa2sk4Ymo4SKPYXXWrHND333ynMvrfGqn',
            status: 'TRANSACTION_STATUS_CONFIRMED',
            created_at: '1970-01-01T00:00:00Z',
          },
        ],
        created_at: '2025-03-24T17:44:11.757962Z',
        finished_at: '2025-03-24T17:47:32.48837Z',
      },
    ],
    total: 14,
  },
}
